<template>
  <div>
    <div  class='topcorner'>
      <el-button v-if="type=='line'" @click="changeType('bar')">切为柱状图展示</el-button>
      <el-button v-if="type=='bar'" @click="changeType('line')">切为拆线图展示</el-button>
    </div>
    <lineChart :type="type" :statOrders="dayStatOrders" :lastYearStatOrders="lastYearDayStatOrders" titleText="15天订单同比数据" showID="line01"></lineChart>
    <lineChart :type="type"  :statOrders="monthStatOrders" :lastYearStatOrders="lastYearMonthStatOrders" titleText="月订单同比数据" showID="line02"></lineChart>
    <div>
        <div style="float: left;width: 50%"><lineChart :type="type"  :statOrders="quarterStatOrders" :lastYearStatOrders="lastYearQuarterStatOrders" titleText="季度订单同比数据" showID="line03"></lineChart></div>
        <div style="float: right;width: 50%"><yearLineChart :type="type"  :statOrders="yearStatOrders" titleText="近5年数据" showID="line04"></yearLineChart></div>
    </div>
  </div>
</template>

<script>
    import lineChart from './LineChart'
    import yearLineChart from './YearLineChart'
    export default {
        name: "StatOrderChart",
        components: {
            lineChart,
            yearLineChart
        },
        data() {
            return {
                dayStatOrders:null,
                lastYearDayStatOrders:null,
                monthStatOrders:null,
                lastYearMonthStatOrders:null,
                quarterStatOrders:null,
                lastYearQuarterStatOrders:null,
                yearStatOrders:null,
                type:"bar",
            }
        },
        mounted(){
            this.initData();
        },
        methods: {
            initData(){
                var that = this;
                that.$api.get('/store/home/orders/stat/day',null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.dayStatOrders = res.data.dayStats;
                            that.lastYearDayStatOrders = res.data.lastYearDayStats;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                });

                that.$api.get('/store/home/orders/stat/month',null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.monthStatOrders = res.data.monthStat;
                            that.lastYearMonthStatOrders = res.data.lastYearMonthStat;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                });

                that.$api.get('/store/home/orders/stat/quarter',null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.quarterStatOrders = res.data.quarterStat;
                            that.lastYearQuarterStatOrders = res.data.lastYearQuarterStat;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                });

                that.$api.get('/store/home/orders/stat/year',null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.yearStatOrders = res.data.yearStat;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                });
            },
            changeType(type){
                this.type = type;
            }
        }
    }
</script>

<style>
  .topcorner{
    height: 80px;
    right:15px;
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/components/StatOrdersChart.vue